import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileAvi.tsx
const IconFileAvi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ed771c",
			fillRule: "evenodd",
			d: "M9 10a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1zm5.543.9 1.35 4.188h1.02l1.362-4.188h-.894l-.624 2.01-.318 1.314h-.018l-.33-1.314-.624-2.01zm-.55 4.188-.3-.996h-1.399l-.3.996h-.924l1.38-4.188h1.128l1.362 4.188zm-1.02-3.36h.03l.467 1.59h-.96zm5.965 2.634v.726h1.992v-.726h-.54v-2.736h.54V10.9h-1.992v.726h.54v2.736z",
			clipRule: "evenodd"
		})
	]
});
var IconFileAvi_default = forwardRef(IconFileAvi);
//#endregion
export { IconFileAvi_default as default };
